import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import {
  FormGroup,
  FormBuilder
} from "@angular/forms";

import { DashboardService } from "../../../shared/services/dashboard/dashboard.service";
import "rxjs/add/operator/debounceTime";
import { CommonService } from '../../../shared/services/common/common.service';
import * as html2canvas from "html2canvas"
import { WidgetHelperService } from '../../../shared/components/graphs/widget-helper.service';

import 'rxjs/Rx' ;


@Component({
    selector: 'pdf-viewer',
    templateUrl: 'pdf-viewer.dialog.html',
    styleUrls: ["pdf-viewer.dialog.scss"]
  })
  export class PdfViewerDialog {
    exportTypeN:string;
    dashboardName:string;
    tempData:any;
    settingForm: FormGroup;
    pdfObject :any ; 
    widgetListGroup:any;
    groupIds:any;
    activeGroupIndex:any;
    isLoadedPdf :boolean=true;
    kpiTypes  = { count : 25,numeric : 50,visual : 50,siteMap : 100,richText:100};
    pdfPropertiesCoordinates = { headerTitle:[5,8],headerDate:[10,5],headerTime : [8], footerFontSize:10 ,headerFontSize:12,headerTimeFontSize:8};
    startXCoordinates = 4;
    startYCoordinates = 20;
    docUrl:string="";
    groupList :any;
    pdfBLOB:any;
    pdfTs =  new Date().getTime();
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private fb:FormBuilder,
      private commonService: CommonService,
      private widgetHelperService: WidgetHelperService,
      public dialogRef: MatDialogRef<PdfViewerDialog>,
      private dashboardService: DashboardService
    ) {
      // this.tempData = data.WidgetIdsData;
      // this.widgetListGroup = data.widgetListGroup;
      // this.groupIds = data.groupIds;
      // this.activeGroupIndex = data.activeGroupIndex;
      this.dashboardName = data.dashboardName;
      // this.groupList = data.groupList;
      this.docUrl = data.url;
      this.exportTypeN = data.exportTypeN;
      this.loadDoc(this.docUrl);
      this.createForm();
      
      // console.log(this.groupList);
    }
  
    createForm(){
      this.settingForm = this.fb.group({
        // paper: ["a4"],
        // orientation: ["landscape"],
        headerTitle: [true],
        headerDate: [true],
        //footerPageNumber: [true]
        includeFilterInfo: [true]
      });
  
        
      this.settingForm.disable();
      // this.subscribeFormChange();
  
    }
  
    changeInPdfFormat():void{
      this.isLoadedPdf = true;
      // let paper = this.settingForm.get('paper').value;
      // let orientation = this.settingForm.get('orientation').value;
      let headerTitle = this.settingForm.get('headerTitle').value;
      let headerDate = this.settingForm.get('headerDate').value;
      let includeFilterInfo = this.settingForm.get('includeFilterInfo').value;
      //let url = this.docUrl + '&isPdfExists=1&paper=' + paper + '&orientation='+orientation + '&headerTitle='+headerTitle + '&headerDate='+headerDate + '&footerPageNumber='+footerPageNumber;
      let url = this.docUrl + '&isPdfExists=1&headerTitle='+headerTitle + '&headerDate='+headerDate + '&includeFilterInfo='+includeFilterInfo;
      this.loadDoc(url);
      this.settingForm.disable();
      // this.preparePdf();
  
    }
  
   loadDoc(url){
        url += "&ts=" + this.pdfTs + "&dashboardname=" + this.dashboardName; 
        this.dashboardService.downloadReport(url).subscribe( (res) => {
          this.pdfBLOB = new Blob([res], {type: res.type});
          this.previewPdf();
          // var link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // if(this.exportTypeN != "pdf")
          //   var fileExt = this.exportTypeN === "excel" ? ".xlsx" :  ".csv"; 
          // else
  
          // var fileName = this.dashboardName + fileExt;
          // link.download = fileName;
          // link.click();
      },(err)=>{
        this.commonService.openSnackBar("Failed while generating " + this.exportTypeN + " report", "");
      });
   }
  
    ngAfterViewInit(){
      // this.preparePdf(() => {
      //   this.previewPdf();
      // });
      // this.getWidgetImages(0);
    }
  
    getWidgetImages(LoopCount){
       // var html = document.getElementsByClassName('mat-tab-body-wrapper');
        // htmlpdfviewer(html, { output: { mode: 'display', container: '#iframeId', height: 800 } });
        var getWidgetIdsData;
        let Recursive = (LoopCount) => {
        var Count = LoopCount;
        getWidgetIdsData = this.widgetListGroup[this.groupIds[this.activeGroupIndex]];
        if(Count <= getWidgetIdsData.length - 1){
          if(getWidgetIdsData[Count].fetchDataFor != "table"){
          let data = document.getElementById(getWidgetIdsData[Count]._id);
          if(getWidgetIdsData[Count].kpiType == "siteMap"){
              let canvasResponse =  this.getMapImage(getWidgetIdsData[Count]);
              getWidgetIdsData[Count].imageWidth = Math.floor(canvasResponse.imageWidth) 
              getWidgetIdsData[Count].imageheight = Math.floor(canvasResponse.imageHeight);
              getWidgetIdsData[Count].ImagesBytes = canvasResponse.mapBytes;
              Count++;
              Recursive(Count);
          }
          else if(data){
          html2canvas(data,{logging:false,useCORS: true})
          .then(canvas => { 
                  // Few necessary setting options 
                  // var imgWidth = 600;truncateSync 
                  // var pageHeight = 600; 
                  // var imgHeight = canvas.height * imgWidth / canvas.width; 
                  // var heightLeft = imgHeight; 
                  const contentDataURL = canvas.toDataURL('image/jpeg');
                  // getWidgetIdsData[Count].imageWidth = canvas.width; 
                  // getWidgetIdsData[Count].imageheight = canvas.height;
                  // let millimeters = { width : 0 ,height:0};
                  getWidgetIdsData[Count].imageWidth = Math.floor(canvas.width * 0.264583);
                  getWidgetIdsData[Count].imageheight = Math.floor(canvas.height * 0.264583);
                  getWidgetIdsData[Count].ImagesBytes = contentDataURL;
                  Count++;
                  Recursive(Count);
          });
        }
        else{
          Count++;
          Recursive(Count);
        }
        }
        else{
          Count++;
          Recursive(Count);
        }
        }
        else
        {
          this.tempData = getWidgetIdsData;
            //this.preparePdf();
        }
      }
      
      if(LoopCount == 0)
        Recursive(LoopCount);
      
    }
  
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
    
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
    
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
    
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
    
        var byteArray = new Uint8Array(byteNumbers);
    
        byteArrays.push(byteArray);
      }
    
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  
    previewPdf(){
      // let dataUrl = this.pdfObject.output('datauristring').split(",");
      let iframe = <HTMLIFrameElement> document.getElementById("pdf-iframe");
      // var blob = this.b64toBlob(dataUrl[1], "application/pdf", 512);
      var blobUrl = URL.createObjectURL(this.pdfBLOB)
      iframe.src = blobUrl;
      this.isLoadedPdf = false;
      this.settingForm.enable();
    }
  
    getImageRatio(maxWidth,maxHeight,imageWidth,imageheigh) : any {
      var maxWidth = maxWidth;//210.00; // Max width for the image
      var maxHeight = maxHeight//297.00;    // Max height for the image
      var ratio = 0;  // Used for aspect ratio
      var width = imageWidth;    // Current image width
      var height = imageheigh;  // Current image height
      var ReturnImage = { width:0,height:0 };
      // Check if the current width is larger than the max
      if(width > maxWidth){
          ratio = maxWidth / width;   // get ratio for scaling image
          ReturnImage.width =  maxWidth; // Set new width
          ReturnImage.height =  height * ratio;  // Scale height based on ratio
          height = height * ratio;    // Reset height to match scaled image
          width = width * ratio;    // Reset width to match scaled image
      }
  
      // Check if current height is larger than max
      if(height > maxHeight){
          ratio = maxHeight / height; // get ratio for scaling image
          ReturnImage.height = maxHeight;   // Set new height
          ReturnImage.width =  width * ratio;    // Scale width based on ratio
          width = width * ratio;    // Reset width to match scaled image
      }
  
      return ReturnImage;
  }
  
    gcd (a, b) {
          return (b == 0) ? a : this.gcd (b, a%b);
    }
    preparePdf(){
      this.pdfObject = new jsPDF(this.settingForm.get("orientation").value, "mm", this.settingForm.get("paper").value);
      var Pdfwidth = this.pdfObject.internal.pageSize.getWidth() - 10;    
      var pdfheight = this.pdfObject.internal.pageSize.getHeight() - 10;
      let pageCount = 1;
      var dateString = new Date().toLocaleString();
      //Add Filters Data
      this.pdfObject.deletePage(1);
      this.pdfObject.addPage();
      this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);
      let xIndexFilter = this.startXCoordinates;
      let yIndexFilter = this.startYCoordinates;
  
            // let filterDt = this.getFilterTable(dateString);
            this.pdfObject.text('Filter values:', 14, 16);
            let filterDt = this.getFilterTable(dateString,Pdfwidth * 0.37);
            var tableJson = this.pdfObject.autoTableHtmlToJson(this.getHtmlElement(filterDt.htmlString));
            this.pdfObject.autoTable(tableJson.columns,tableJson.data,{
              startY: this.startYCoordinates,
              theme: 'plain',
              styles:{
                fontSize: 9
              },
              addPageContent: data => {
              // if(lastYIndex === this.startYCoordinates || lastYIndex > pdfheight){
              
                //Header
              if(this.settingForm.get("headerTitle").value){
                  this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerFontSize);                
                  this.pdfObject.text(this.dashboardName, this.pdfPropertiesCoordinates.headerTitle[0] ,this.pdfPropertiesCoordinates.headerTitle[1]);
              }
  
              
              if(this.settingForm.get("headerDate").value){
                this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerTimeFontSize);                
                this.pdfObject.text(dateString, (Pdfwidth*3)/4 , this.pdfPropertiesCoordinates.headerTime[0]);
              }
                //Footer  
              if(this.settingForm.get("includeFilterInfo").value){
                this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);                
                this.pdfObject.text(pageCount.toString(), Pdfwidth * 0.5 ,pdfheight - 4);
              }
                
                pageCount++;
              // }
              }
            });
          
      
      // //Footer
      // if(this.settingForm.get("footerPageNumber").value){
      //     this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);                  
      //     this.pdfObject.text(Pdfwidth * 0.5 ,pdfheight - 4, pageCount.toString());
      //   }
      //     pageCount++;
  
      let getWidgetIdsData = this.tempData;
      let LoopCount = 0;
      let countLength = 0;
      let maxYCoordinates = 0;
      let RecursivePdf = (LoopCount,refxCordinates,refyCordinates,maxYCoordinates) => {
        // this.pdfObject.setPage(LoopCount);
        var Count = LoopCount;
        let xCoordinate = 0;
        let yCoordinate = 0;
        if(Count <= getWidgetIdsData.length - 1){
          let imageWidth =  getWidgetIdsData[Count].imageWidth || 0;
          let imageheight = getWidgetIdsData[Count].imageheight || 0;
          let widgetWidthConfig = getWidgetIdsData[Count].widgetConfig ? getWidgetIdsData[Count].widgetConfig.width : 0;
          widgetWidthConfig = widgetWidthConfig === 0 ?  this.kpiTypes[getWidgetIdsData[Count].kpiType] : widgetWidthConfig;  
          let gcdVal = this.gcd(imageWidth,imageheight);
          let imageWidthRatio = imageWidth/gcdVal;
          let imageHeigthRatio = imageheight/gcdVal;
          let imagePdfWidth = Pdfwidth * (widgetWidthConfig/100);
          let imagePdfHieght = (imagePdfWidth/imageWidthRatio) * imageHeigthRatio;
          
          
          // widgetWidthConfig = widgetWidthConfig/100;
          // var Ratio = {width :imageWidth ,height:imageheight };
          // if(imageWidth >= Pdfwidth || imageheight >= pdfheight){
              //  Ratio = this.getImageRatio(Pdfwidth*widgetWidthConfig,pdfheight*widgetWidthConfig,imageWidth,imageheight);
              //  getWidgetIdsData[Count].compressimageWidth = Ratio.width == 0 ? imageWidth : Ratio.width ; 
              //  getWidgetIdsData[Count].compressimageheight = Ratio.height == 0 ? imageheight : Ratio.height;
               getWidgetIdsData[Count].compressimageWidth = imagePdfWidth ; 
               getWidgetIdsData[Count].compressimageheight = imagePdfHieght;
          // }
          if(getWidgetIdsData[Count].fetchDataFor === "table")
          { 
              let tableHtmls = this.getTableHtmlString(getWidgetIdsData[Count].response,Math.floor(Pdfwidth*0.4),Math.floor(pdfheight*0.8));
              let lastYIndex = this.startYCoordinates;
              tableHtmls.forEach((tblHtml) => {
  
                if(lastYIndex === this.startYCoordinates || lastYIndex > pdfheight){
                  this.pdfObject.addPage();
                }
                var tableJson = this.pdfObject.autoTableHtmlToJson(this.getHtmlElement(tblHtml));
                this.pdfObject.autoTable(tableJson.columns,tableJson.data,{
                  startY: lastYIndex,
                  theme: 'grid',
                  styles:{
                    fontSize: 9
                  },
                  addPageContent: data => {
                  if(lastYIndex === this.startYCoordinates || lastYIndex > pdfheight){
                  
                    //Header
                  if(this.settingForm.get("headerTitle").value){
                      this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerFontSize);                
                      this.pdfObject.text(this.dashboardName, this.pdfPropertiesCoordinates.headerTitle[0] ,this.pdfPropertiesCoordinates.headerTitle[1]);
                  }
  
                  
                  if(this.settingForm.get("headerDate").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerTimeFontSize);                
                    this.pdfObject.text(dateString, (Pdfwidth*3)/4 , this.pdfPropertiesCoordinates.headerTime[0]);
                  }
                    //Footer  
                  if(this.settingForm.get("includeFilterInfo").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);                
                    this.pdfObject.text(pageCount.toString(), Pdfwidth * 0.5 ,pdfheight - 4);
                  }
                    
                    pageCount++;
                  }
                  }
                });
                lastYIndex = this.pdfObject.autoTable.previous.finalY + 3;
              });
              countLength = 0;
          }
          else 
          { 
            let widgetGap = 3;
              if(getWidgetIdsData[Count].ImagesBytes)
              {
                if(countLength == 0){
                      this.pdfObject.addPage();   
  
                  //header
                  if(this.settingForm.get("headerTitle").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerFontSize);                  
                    this.pdfObject.text(this.pdfPropertiesCoordinates.headerTitle[0] ,this.pdfPropertiesCoordinates.headerTitle[1],this.dashboardName);
                  }
  
  
                   
                  if(this.settingForm.get("headerDate").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerTimeFontSize);                
                    this.pdfObject.text((Pdfwidth*3)/4 ,this.pdfPropertiesCoordinates.headerTime[0],dateString);
                  }
                  
                  //Footer
                    if(this.settingForm.get("includeFilterInfo").value){
                      this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);                  
                      this.pdfObject.text(Pdfwidth * 0.5 ,pdfheight - 4, pageCount.toString());
                    }
                      pageCount++;
                }
  
                xCoordinate = countLength == 0 ? this.startXCoordinates : refxCordinates;
                yCoordinate = countLength == 0 ? this.startYCoordinates : refyCordinates;
  
                
                getWidgetIdsData[Count].compressimageWidth -= (widgetGap/2);
                
                if(countLength !=0 && xCoordinate + getWidgetIdsData[Count].compressimageWidth > (Pdfwidth + 10)){
                  xCoordinate = this.startXCoordinates;
                  let previousImageH = getWidgetIdsData[Count-1].compressimageheight;
                  if(maxYCoordinates > previousImageH)
                    yCoordinate = refyCordinates + maxYCoordinates;
                  else
                    yCoordinate = refyCordinates + getWidgetIdsData[Count-1].compressimageheight + widgetGap; // getWidgetIdsData[i].imageheight + 5;
                  }
                
                  if(countLength !=0 && yCoordinate + getWidgetIdsData[Count].compressimageheight > pdfheight){
                  this.pdfObject.addPage();
                  countLength = 0;
                  xCoordinate=this.startXCoordinates;
                  yCoordinate=this.startYCoordinates;
                  maxYCoordinates = 0;
  
                  if(this.settingForm.get("headerTitle").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerFontSize);                
                    this.pdfObject.text(this.pdfPropertiesCoordinates.headerTitle[0] ,this.pdfPropertiesCoordinates.headerTitle[1],this.dashboardName);
                  }
                  if(this.settingForm.get("headerDate").value){
                      this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.headerTimeFontSize);                
                      this.pdfObject.text((Pdfwidth*3)/4 , this.pdfPropertiesCoordinates.headerTime[0],dateString);
                  }
  
                  //Footer
                  if(this.settingForm.get("includeFilterInfo").value){
                    this.pdfObject.setFontSize(this.pdfPropertiesCoordinates.footerFontSize);
                    this.pdfObject.text(Pdfwidth * 0.5,pdfheight - 4, pageCount.toString());
                  }
                    pageCount++;
                }
                  
                  this.pdfObject.addImage(getWidgetIdsData[Count].ImagesBytes, 'JPEG', xCoordinate, yCoordinate,getWidgetIdsData[Count].compressimageWidth ,getWidgetIdsData[Count].compressimageheight);
  
  
            countLength++;
            xCoordinate = xCoordinate + getWidgetIdsData[Count].compressimageWidth + widgetGap;
            yCoordinate = yCoordinate; 
            maxYCoordinates = maxYCoordinates > getWidgetIdsData[Count].compressimageheight + widgetGap ? maxYCoordinates : getWidgetIdsData[Count].compressimageheight + widgetGap;
            }
          }
          Count++;
          RecursivePdf(Count,xCoordinate,yCoordinate,maxYCoordinates);
  
        }
        else
        {
          this.previewPdf();
          // this.pdfObject.save(Math.floor(Date.now()/1000) + '.pdf');
        }
      }
      
      if(LoopCount == 0)
        RecursivePdf(LoopCount,0,0,0);
    }
  
    printPdf(){
      // this.pdfObject.save(Math.floor(Date.now()/1000) + '.pdf');
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(this.pdfBLOB);
        var fileExt = ".pdf"; 
        var fileName = this.dashboardName + fileExt;
        link.download = fileName;
        link.click();
    }
  
  
  getTableHtmlString(dataFilterValue :any,pdfWidth,pdfHeight) {
    let tableHtml = [];
    if(dataFilterValue) {
      let Response = this.widgetHelperService.getDataTable(dataFilterValue,{pageIn : -1, pageSize : -1},false);
      tableHtml = this.getHtmlJson(Response.Site,Response.ValueFilter,Response.Data,pdfWidth,pdfHeight);
    }
    return tableHtml;
  }
  
  getHtmlElement(htmlString) {
    var el = <HTMLElement> document.createElement('div');
    el.innerHTML = htmlString;
    return el.childNodes[0];
  }
  
  getHtmlJson(sites,valueFilter,rowData,columL,rowL){
      var headers = this.getHeader(sites,valueFilter,columL,columL);
      var htmlBody = this.getTableData(headers.tableHeader,rowData,valueFilter)
      var Html = this.getTableHtml(headers.tableHeaderHtml,htmlBody,rowL);
      return Html;
  }
  
  
  getHeader(sites,valueFilter,columL,pdfHeaderL){
      var tableHeaderHtml = [];
      var tableHeader = [];
      let i = 0;
      var columnHead=0;
      var headerHtml = "";
        //This fucntion will return single header and mutiple 
    //if site length is 0 will push empty and table will contain single header.   
    if(!sites || sites.length == 0){
      sites = [""];
    }
    
      var headerL = 0 ;
      var headerPdfL = pdfHeaderL;
      sites.forEach((site, j)=> {
          
          //tableHeader[i] = !tableHeader[i] ? [] : tableHeader[i].push(site);
          //count character in header
          headerL += site.length  * valueFilter.length;
          valueFilter.forEach((vf)=>{
              headerL += (vf.length * sites.length);
          });
          
          //column count in header
          columnHead = columnHead + valueFilter.length;
          if(columnHead > columL){
              columnHead = valueFilter.length;
              tableHeaderHtml.push("<tr>" + headerHtml +"</tr>");
        headerHtml 	="";
        headerL = 0;
              i++;
          }
          headerHtml = headerHtml == "" ? "<th>Date</th>" : headerHtml;
          if(!tableHeader[i]){
              tableHeader[i] = [];
          }	
          tableHeader[i].push(site);
          valueFilter.forEach((vf)=>{
        headerHtml += site != "" ? "<th>" + site + "-" + vf + "</th>" : "<th>" + vf + "</th>";;
              
          });
          
          if(j == sites.length - 1 || (headerL > headerPdfL)){
              columnHead = 0;
              tableHeaderHtml.push("<tr>" + headerHtml +"</tr>");
        headerHtml 	="";
        headerL = 0;
              i++;
          }
      });
      return {tableHeaderHtml:tableHeaderHtml, tableHeader:tableHeader };
  }
  
  
  getTableData(tHeader,data,valueFilter){
      
      var tableHtmlBody = [];
      var trHtml = [];
      tHeader.forEach((tHs,i)=>{
          
          if(!tableHtmlBody[i]){
              tableHtmlBody[i] = [];
          }
          
          data.forEach((objDa)=>{
              if(!tableHtmlBody[i][objDa.date]){
                  tableHtmlBody[i][objDa.date] = [];
                  
                  //Will be used for mutiple headers and single headers
                  tHs.forEach((objTH)=>{
            //objTH == "" is used becz we are passing empty string if it contains single headers
                      if(objTH == objDa.Label || objTH == ""){
                          valueFilter.forEach(Vf=>{
                              trHtml.push("<td>" +  objDa[Vf]  + "</td>");
                          });
                      }
                      else{
                          valueFilter.forEach(Vf => {
                              trHtml.push("<td>0</td>");
                          })
                      }
                      
                  });
                  
                  tableHtmlBody[i][objDa.date] = trHtml;
                  trHtml=[];
                  
              }
              else{
                  tHs.forEach((objTH, j)=>{
                      if(objDa.Label == objTH || objTH == ""){
                      let index = j * valueFilter.length;
                      valueFilter.forEach((Vf)=>{
                          if(objDa[Vf] > 0)
                              tableHtmlBody[i][objDa.date][index] = "<td>" + objDa[Vf] + "</td>";
                          index++;
                      });
                  } 
                  });
              }
          });
          
          
      });
      
      return tableHtmlBody;
  }
  
  getTableHtml(headers,bodies,rowL){
   var html = [];
   let rowCount = 1;
   var htmlHeaderString = "";
   var htmlBodyString = ""; 
    headers.forEach((objH, h) => {
      
      //header for table
      htmlHeaderString = objH;
  
      //body for table
      //get rows for table body
        var body = bodies[h] || [];
        for(var key in  body){
            
          //create rows for table
          htmlBodyString += "<tr>";
          htmlBodyString += "<td>" + key + "</td>";		
          body[key].forEach((objT)=> { 
              htmlBodyString +=  objT;
          });
          htmlBodyString += "</tr>";
          
              
          
          //create a table if rowL matched		
          if(rowCount >= rowL){
              var table = "<table>";
              table += htmlHeaderString;
              table +=htmlBodyString;
              table += "</table>";
              
              html.push(table);
              table = "";
              htmlBodyString = "";
              rowCount = 0;
          }
         } 
         
         //create a table of remaining data		
          if(rowCount != 0){
              var table = "<table>";
              table += htmlHeaderString;
              table +=htmlBodyString;
              table += "</table>";
              
              html.push(table);
              table = "";
              htmlBodyString = "";
              rowCount = 0;
          }
              
          rowCount++;
     });
  return html;
  }
  
  getMapImage(kpiData): any{
    let canvas2 = <HTMLCanvasElement> document.createElement("canvas");
    let mBytes='';
    let iWidth=0;
    let iHeight=0;
    if(kpiData){
      let img = <HTMLImageElement>document.querySelector("#google-static-" + kpiData._id);
      canvas2.height = img.height;
      canvas2.width = img.width;
      iWidth = img.width;
      iHeight = img.height;
      canvas2.getContext("2d").drawImage(img, 0, 0, iWidth, iHeight, 0, 0, iWidth, iHeight);
      mBytes = canvas2.toDataURL("image/jpeg");
      canvas2.remove();
    }
    return { mapBytes : mBytes,imageWidth : iWidth,imageHeight:iHeight};
  }
  
  getFilterTable(dateTime,Pdfwidth) : { htmlString : string  }{
    let FilterHeaders = [ "Sites","Brands","Zones","Show Specific Date","Pdf generation date","From","To","Consolidate Site Data","Consolidate Data"];
    let dataValue = [];
    let htmlTable = "";
    if(this.groupList && this.groupList.length>0)
    { 
      let groupList = this.groupList[this.activeGroupIndex];
      htmlTable = "<table><tr><th></th><th></th></tr>";
  
      htmlTable += "<tr><td>"+ FilterHeaders[4] +"</td><td>" + dateTime + "</td></tr>";
  
      //siteNames
      let siteNames = [];
      let sitesstring = "";
      let countsites = (groupList.sitesRes.length-1) || -1;
      if(countsites >= 0){
      groupList.sitesRes.forEach((objsite,i)=>{
        let currenString = objsite.siteName;
        let nextString = "";
        if(i != countsites)
            nextString =  groupList.sitesRes[i+1].siteName;
        
        sitesstring += currenString;  //objBrand.brandName + "-" + objBrand.brandCategoryName;
        sitesstring += i != countsites ? ", " : "";   
        if((sitesstring.length > Pdfwidth && (sitesstring + nextString).length > Pdfwidth)  || i == countsites){
          siteNames.push("<td>" + sitesstring  +"</td>");
          sitesstring = "";
        }
      });
  
      siteNames.forEach((siteN,i)=>{
          if(i==0){
            htmlTable += "<tr><td>" + FilterHeaders[0] + "</td>" + siteN  + "</tr>";
          }
          else{
            htmlTable += "<tr><td></td>" + siteN  + "</tr>";          
          }
      });
    }
    else{
      htmlTable += "<tr><td>" + FilterHeaders[0] + "</td><td>--</td></tr>";
    }
  
  
  
  
  
      //Brand Names
      let brandsNames = [];
      let brandsstring = "";
      let countbrands = (groupList.brandsRes.length-1) || -1;
      if(countbrands >= 0){
      groupList.brandsRes.forEach((objBrand,i)=>{
        let currenStringL = objBrand.brandName + "-" + objBrand.brandCategoryName;
        let nextStringL = "";
        if(i != countbrands)
            nextStringL =  groupList.brandsRes[i+1].brandName + "-" + groupList.brandsRes[i+1].brandCategoryName;
        brandsstring += currenStringL;  //objBrand.brandName + "-" + objBrand.brandCategoryName;
        brandsstring += i != countbrands ? ", " : "";   
        if((brandsstring.length > Pdfwidth && (brandsstring + nextStringL+2).length > Pdfwidth)  || i == countbrands){
            brandsNames.push("<td>" + brandsstring  +"</td>");
            brandsstring = "";
        }
        //siteNames += objSite.siteName + " ";
      });
  
      brandsNames.forEach((brandN,i)=>{
          if(i==0){
            htmlTable += "<tr><td>" + FilterHeaders[1] + "</td>" + brandN  + "</tr>";
          }
          else{
            htmlTable += "<tr><td></td>" + brandN  + "</tr>";          
          }
      });
    }
    else{
      htmlTable += "<tr><td>" + FilterHeaders[1] + "</td><td>--</td></tr>";
    }
  
      //zone Names
      let zonesNames = [];
      let zonesstring = "";
      let countzones = (groupList.zonesRes.length-1) || -1;
      if(countzones >= 0){
      groupList.zonesRes.forEach((objzone,i)=>{
        let currenString = objzone.zoneName;
        let nextStringL = "";
        if(i != countzones)
            nextStringL =  groupList.zonesRes[i+1].zoneName;
          zonesstring += currenString;  //objBrand.brandName + "-" + objBrand.brandCategoryName;
          zonesstring += i != countzones ? ", " : "";   
        if((zonesstring.length > Pdfwidth && (zonesstring + nextStringL).length > Pdfwidth)  || i == countzones){
            zonesNames.push("<td>" + zonesstring  +"</td>");
            zonesstring = "";
        }
      });
  
      zonesNames.forEach((zoneN,i)=>{
          if(i==0){
            htmlTable += "<tr><td>" + FilterHeaders[2] + "</td>" + zoneN  + "</tr>";
          }
          else{
            htmlTable += "<tr><td></td>" + zoneN  + "</tr>";          
          }
      });
    }
    else{
      htmlTable += "<tr><td>" + FilterHeaders[2] + "</td><td>--</td></tr>";
    }
  
  
    // showSpecificDate
      let showSpecificDateNames = [];
      let showSpecificDatestring = "";
      let countshowSpecificDate = (groupList.showSpecificDate.length-1) || -1;
      if(countshowSpecificDate >= 0){
        groupList.showSpecificDate["showSpecificDateString"] = this.widgetHelperService.getSpecificDate(groupList.groupByTimeFrame,groupList.showSpecificDate);
      
      groupList.showSpecificDate.showSpecificDateString.forEach((objzone,i)=>{
        let currenString = objzone;
        let nextStringL = "";
        if(i != countshowSpecificDate)
            nextStringL =  groupList.showSpecificDate.showSpecificDateString[i+1];
            showSpecificDatestring += currenString;  
            showSpecificDatestring += i != countshowSpecificDate ? ", " : "";   
        if((showSpecificDatestring.length > Pdfwidth && (showSpecificDatestring + nextStringL).length > Pdfwidth)  || i == countshowSpecificDate){
          showSpecificDateNames.push("<td>" + showSpecificDatestring  +"</td>");
            showSpecificDatestring = "";
        }
      });
  
      showSpecificDateNames.forEach((specificN,i)=>{
          if(i==0){
            htmlTable += "<tr><td>" + FilterHeaders[3] + "</td>" + specificN  + "</tr>";
          }
          else{
            htmlTable += "<tr><td></td>" + specificN  + "</tr>";          
          }
      });
      }
      else{
      htmlTable += "<tr><td>" + FilterHeaders[3] + "</td><td>--</td></tr>";
      }
  
  
      
  
  
      htmlTable += "<tr><td>" + FilterHeaders[5] + "</td><td>" + groupList.from + "</td></tr>";
  
  
      htmlTable += "<tr><td>" + FilterHeaders[6] + "</td><td>" + groupList.to + "</td></tr>";
  
      let consolidateSiteData = groupList.consolidateSiteData == "0" ? "No" : "Yes";
      htmlTable += "<tr><td>" + FilterHeaders[7] + "</td><td>" + consolidateSiteData  + "</td></tr>";
  
  
      let consolidateData = groupList.consolidateData == "0" ? "No" : "Yes";
      htmlTable += "<tr><td>" + FilterHeaders[8] + "</td><td>" + consolidateData + "</td></tr>";
      
      htmlTable += "</table>";
    }
    return { htmlString : htmlTable };
  }
  }


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/pdfviewer/pdf-export-dialog.component.ts